import { Form, FormRenderProps } from 'react-final-form';
import { connect, useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';
import { useCallback } from 'react';

import { Button } from 'UIPackage/MainModule/components/Button';
import { Modal } from 'UIPackage/ModalModule/components/Modal';
import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';
import { ISimilarityStatusEnum } from 'APIPackage/SimilarityModule/interfaces/ISimilarityStatus';
import { SYSTEM_DATE_FORMAT_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { getSimilaritiesPersonId } from 'SimilaritiesPackage/MainModule/selectors/similaritiesSelectors';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { similaritiesChangeStatus } from 'SimilaritiesPackage/MainModule/actions/similaritiesActions';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { ModalHeader } from 'UIPackage/ModalModule/components/ModalHeader';
import { ModalBody } from 'UIPackage/ModalModule/components/ModalBody';
import { ModalActions } from 'UIPackage/ModalModule/components/ModalActions';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { SelectInputField } from 'UIPackage/MainModule/components/SelectInputField';

import styles from './SimilaritiesByPersonDateModal.module.scss';

interface ISimilaritiesByPersonDateModalProps {
  isVisible?: boolean;
  onClose: () => void;
  knmDateOptions: ISelectOption[];
  activeIds: string[] | number[];
  personId: string | undefined;
}

interface IFiltersModalForm {
  startDate: ISelectOption;
}

const SimilaritiesByPersonDateModalWithoutStore = ({
  isVisible,
  onClose,
  knmDateOptions,
  activeIds,
  personId,
}: ISimilaritiesByPersonDateModalProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();

  const onSubmit = useCallback(
    (data: IFiltersModalForm) => {
      const { startDate } = data;
      const startingDate: string = formatDate({ date: startDate.value, dateFormat: SYSTEM_DATE_FORMAT_FNS });

      dispatch(
        similaritiesChangeStatus(
          ISimilarityStatusEnum.JOINTLY,
          personId ?? '',
          startingDate,
          { knmIds: activeIds },
          true,
        ),
      );
      onClose();
    },
    [activeIds, dispatch, onClose, personId],
  );

  const renderForm = useCallback(
    ({ handleSubmit }: FormRenderProps<IFiltersModalForm>) => (
      <form onSubmit={handleSubmit}>
        <ModalHeader title="Совмещение" color="black" />
        <ModalBody size="content" border="bottom">
          <FieldBlock color="black" label="Выберите дату начала КНМ из списка доступных">
            <SelectInputField name="startDate" options={knmDateOptions} />
          </FieldBlock>
        </ModalBody>
        <ModalActions>
          <Button type="submit" color="primary" size="medium" text="Совместить" />
          <Button type="button" onClick={onClose} color="default" size="medium" text="Отменить" />
        </ModalActions>
      </form>
    ),
    [knmDateOptions, onClose],
  );

  return (
    <Modal modalBodyClassName={styles.Modal} visible={isVisible} onClose={onClose}>
      <Form<IFiltersModalForm> onSubmit={onSubmit} render={renderForm} />
    </Modal>
  );
};

const mapStateToProps = (state: IRootState) => ({
  personId: getSimilaritiesPersonId(state),
});

export const SimilaritiesByPersonDateModal = connect(mapStateToProps)(SimilaritiesByPersonDateModalWithoutStore);
